import React from "react";
import styled, { css } from "styled-components";
import { borderWidth, colors, radius, sizes, spacings } from "../assets/themes";
import { uuid } from "../utils/index";
import Icon from "./icon";
import { CheckboxBase, CheckboxLabelBase } from "./styles/base";
import { CHECKBOX } from "@/components/styles/variants/checkbox";
import { Body16 } from "./text";

const StyledInput = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0;
`;

const StyledText = styled(Body16)`
  ${({ disabled }) => css`
    user-select: none;
    opacity: ${disabled ? 0.5 : 1};
    margin-left: ${spacings.s};
  `}
`;

const EnhancedCheckboxBase = styled(CheckboxBase)`
  ${({ checked }) => css`
    overflow: hidden;
    box-sizing: border-box;
    border: none;
    &:before {
      transition: all 0.1s ease-in-out;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-style: solid;
      border-radius: ${radius.xs};
      border-width: ${checked ? `calc(${sizes.size20} / 2)` : borderWidth.ml};
      border-color: ${checked ? colors.primary : colors.mutedLight};
    }
  `}
`;

const Checkbox = ({
  className,
  name,
  children,
  disabled,
  checked,
  onChange,
  readOnly,
  ...rest
}) => (
  <CheckboxLabelBase
    aria-checked={checked}
    checked={checked}
    className={className}
    disabled={disabled}
    readOnly={readOnly || !onChange}
  >
    <EnhancedCheckboxBase checked={checked} disabled={disabled} shape={CHECKBOX.SHAPE.DEFAULT}>
      <StyledInput
        checked={checked}
        disabled={disabled}
        name={name}
        onChange={onChange}
        readOnly={readOnly || !onChange}
        value
        {...rest}
      />
      {checked && (
        <Icon.Medium
          color={colors.background}
          css={`
            position: relative;
          `}
          name="check"
        />
      )}
    </EnhancedCheckboxBase>
    {children && <StyledText disabled={disabled}>{children}</StyledText>}
  </CheckboxLabelBase>
);

export default Checkbox;
